import { Link, useLocation } from "react-router-dom";
import { LOGO_URL } from "../lib/constants";
import { ShieldCheck } from "lucide-react";

export default function Header() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full bg-white/85 backdrop-blur-xl border-b border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
        >
          <div className="h-10 w-10 rounded-md bg-[#0B192C] flex items-center justify-center overflow-hidden ring-1 ring-[#0B192C]/10">
            <img
              src={LOGO_URL}
              alt="Car Hurt Help"
              className="h-10 w-10 object-cover"
            />
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg tracking-tight text-[#0B192C] font-bold">
              Car Hurt Help
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#4B5563] -mt-0.5">
              Accident Intake
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          {!isAdmin && (
            <span
              className="hidden sm:inline-flex items-center gap-1.5 text-xs text-[#4B5563]"
              data-testid="header-trust-badge"
            >
              <ShieldCheck className="h-4 w-4 text-[#0B192C]" />
              Confidential & Secure
            </span>
          )}
          {!isAdmin && (
            <Link
              to="/start"
              data-testid="header-cta-button"
              className="inline-flex items-center rounded-md bg-[#D32F2F] hover:bg-[#B71C1C] text-white text-sm font-semibold px-4 py-2 shadow-sm transition-colors"
            >
              Start My Claim
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
